import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { mtfindCpvId } from "../api/mtfindCpvId";
import { getImages } from "../api/getImages";
import { generarImagenReporte } from "../api/generarImagenReporte";
import Modal from 'react-bootstrap/Modal';
import "./style.css"
import "./print.css";
import { jsPDF } from "jspdf";

function AutoTransporte() {

  const componentRef = useRef(null);
  const isRunned = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [validateCurpCpv, setValidateCurpCpv] = useState(false);

  const [imagenFront, setImagenFront] = useState("");
  const [imagenBack, setImagenBack] = useState("");

  /*---Nombre reporte---*/

  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');
  const [cpv, setCpv] = useState(params.get("i"));

  /*----------------------*/

  const [vigenciaCpv, setVigenciaCpv] = useState("");
  const [robos, setRobos] = useState("");
  const [robosTxt, setRobosTxt] = useState("");
  const [accidentes, setAccidentes] = useState("");
  const [accidentesTxt, setAccidentesTxt] = useState("");
  const [distancias, setDistancias] = useState("");
  const [conduccion, setConduccion] = useState("");
  const [experiencia, setExperiencia] = useState("");
  const [equipo, setEquipo] = useState("");

  const [numeroLic, setNumeroLic] = useState("");
  const [tipoLic, setTipoLic] = useState("");
  const [vigencia, setVigencia] = useState("");
  const [edoEmisorISO, setEdoEmisorISO] = useState("");
  const [edoEmisor, setEdoEmisor] = useState("");
  const [similarity, setSimilarity] = useState("");
  const [numImagenSimilarity, setNumImagenSimilarity] = useState("");
  const [numImagenExperiencia, setNumImagenExperiencia] = useState("");
  const [numImagenCapacidad, setNumImagenCapacidad] = useState("");
  const [numImagenCompetencia, setNumImagenCompetencia] = useState("");
  const [imagenLogoDPRStr, setImagenLogoDPRStr] = useState("");
  const [carLogisticStr, setCarLogisticStr] = useState("");
  const [checkDeepBlueStr, setCheckDeepBlueStr] = useState("");

  const [experienciaRes, setExperienciaRes] = useState("");
  const [capacidadRes, setCapacidadRes] = useState("");
  const [competencia, setCompetencia] = useState("");
  const [conocimiento, setConocimiento] = useState("");
  const [alcohol, setAlcohol] = useState("");
  const [fatiga, setFatiga] = useState("");
  const [peatones, setPeatones] = useState("");
  const [interseccion, setInterseccion] = useState("");
  const [imageShare, setImageShare] = useState("");

  const valorCicloAreas = 10;
  const [fatigaArr, setFatigaArr] = useState([]);
  const [peatonesArr, setPeatonesArr] = useState([]);
  const [conocimientoArr, setConocimientoArr] = useState([]);
  const [alcoholArr, setAlcoholArr] = useState([]);
  const [interArr, setInterArr] = useState([]);
  const [showTendencia, setShowTendencia] = useState(false);
  const [emiteTxt, setEmiteTxt] = useState("");
  const [validadoTxt, setValidadoTxt] = useState("");
  const [fechaValidacionLicIncode, setFechaValidacionLicIncode] = useState("");


  const [cardSvgP, setCardSvgP] = useState("");
  const [logoDPR, setLogoDPR] = useState("");
  const [check_deepBlue, setCheck_deepBlue] = useState("");
  const [cardSvgBlack, setCardSvgBlack] = useState("");
  const [userExample, setUserExample] = useState("");
  const [fakeExample, setFakeExample] = useState("");
  const [fakeExample2, setFakeExample2] = useState("");
  const [qr, setQr] = useState("");

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {

    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {

      localStorage.clear();

      if (params.get("i") == null) {

        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv")

      } else {

        setLoading(true);

        const dataImgRepo = await generarImagenReporte();

        const cardSvgPStr =
          "data:image/png;base64," + dataImgRepo.cardSvgP + "";

        const logoDPRStr =
          "data:image/png;base64," + dataImgRepo.logoDPR + "";

        const check_deepBlueStr =
          "data:image/png;base64," + dataImgRepo.check_deepBlue + "";

        const cardSvgBlackStr =
          "data:image/png;base64," + dataImgRepo.cardSvgBlack + "";

        const qrStr =
          "data:image/png;base64," + dataImgRepo.qr + "";


        setLogoDPR(logoDPRStr);
        setCardSvgP(cardSvgPStr);
        setCheck_deepBlue(check_deepBlueStr);
        setCardSvgBlack(cardSvgBlackStr);
        setQr(qrStr);

        const objCpv = {
          cpv: params.get("i"),
        };

        const response = await mtfindCpvId(objCpv);

        if (response.status === 200) {

          /** 
           * Agrego validacion para el llenado de las areas evaluadas 
           * Validacion para el llenado de las imagenes de porcentaje
           */

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.numImagenFatiga) {
              fatigaArr.push(<span className="mark"></span>)
            } else {
              fatigaArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.numImagenPeatones) {
              peatonesArr.push(<span className="mark"></span>)
            } else {
              peatonesArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.numImagenConocimiento) {
              conocimientoArr.push(<span className="mark"></span>)
            } else {
              conocimientoArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.numImagenAlcohol) {
              alcoholArr.push(<span className="mark"></span>)
            } else {
              alcoholArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.numImagenInterseccion) {
              interArr.push(<span className="mark"></span>)
            } else {
              interArr.push(<span></span>)
            }
          }

          /** Imagenes para generar el reporte */

          const imagenCompetencia =
            "data:image/png;base64," + response.numImagenCompetencia + "";
          setNumImagenCompetencia(imagenCompetencia);

          const imagenExperiencia =
            "data:image/png;base64," + response.numImagenExperiencia + "";
          setNumImagenExperiencia(imagenExperiencia);

          const imagenCapacidad =
            "data:image/png;base64," + response.numImagenCapacidad + "";
          setNumImagenCapacidad(imagenCapacidad);

          const imagenSimilarity =
            "data:image/png;base64," + response.numImagenSimilarity + "";
          setNumImagenSimilarity(imagenSimilarity);

          if (response.similarity === "0") {
            setValidadoTxt("Inválido / DPR");
          } else {
            setValidadoTxt("Válido / DPR " + response.vigenciaLicIncode);
          }


          const imagenLogoDPR =
            "data:image/png;base64," + response.logoDPR + "";
          setImagenLogoDPRStr(imagenLogoDPR);

          const imagenCarLogistic =
            "data:image/png;base64," + response.carLogistic + "";
          setCarLogisticStr(imagenCarLogistic);

          const imagenCheckDeepBlue =
            "data:image/png;base64," + response.checkDeepBlue + "";
          setCheckDeepBlueStr(imagenCheckDeepBlue);

          if (response.numImageTendencia === 1) {
            setShowTendencia(true);
          } else {
            setShowTendencia(false);
          }


          setCpv(response.cpv);
          setVigenciaCpv(response.vigenciaCpv);
          setRobos(response.robos);
          setAccidentes(response.accidentes);
          setRobosTxt("Robos");
          setAccidentesTxt("Accidentes");
          setConduccion(response.conduccion);
          setFechaValidacionLicIncode(response.vigenciaLicIncode);

          setConduccion(response.conduccion);
          setDistancias(response.distancias);
          setExperiencia(response.experiencia);
          setEquipo(response.equipo);
          setNumeroLic(response.numeroLic);
          setTipoLic(response.tipoLic);
          setVigencia(response.vigencia);
          setEdoEmisorISO(response.edoEmisorISO);
          setEdoEmisor(response.edoEmisor);
          setSimilarity(response.similarity);

          setExperienciaRes(response.experienciaRes);
          setCapacidadRes(response.capacidad);
          setCompetencia(response.competencia);

          setConocimiento(response.conocimiento);
          setAlcohol(response.alcohol);
          setFatiga(response.fatiga);
          setPeatones(response.peatones);
          setInterseccion(response.interseccion);
          setEmiteTxt(response.emiteTxt);

          const objIncode = {
            interviewId: response.interviewIdLic,
            tokenIncode: response.tokenIncodeLic,
            cpv: params.get("i"),
          };

          const responseImg = await getImages(objIncode);

          setImagenFront(responseImg.croppedFrontID);
          setImagenBack(responseImg.croppedBackID);

          handlePrint();


        } else {

          setLoading(false);
          setShow(true);
          setShowStatus(response.status);
          setShowMessage(response.message);

        }
      }
    }

    createSession();

  }, []);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    print: async () => {
      const doc = new jsPDF();
      doc.html(componentRef.current, {
        html2canvas: {
          scale: 0.19
        },
        margin: 0,
        x: 3.5,
        async callback(doc) {
          await doc.save('Autotransporte _' + cpv + '_' + formattedDate);
        },
      });
    },

  });

  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

      <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
        <div
          className=" animate__animated animate__fadeIn"
          ref={componentRef}
          style={{ display: "flex", width: "1070px", border: "none" }}
        >
          <div className="relativeCSS">
            <style type="text/css" media="print">
              {
                "@page {  size: A4;  }"
              }
            </style>

            {/* hoja 1 */}
            <br />
            <div className="container-fluid ">
              <div className="row">
                <div className="col-6">
                  <article className="identify-card ">
                    <aside className="account-detail gray w25">
                      <section className="detail-image">
                        <img src={logoDPR} alt="" />
                      </section>
                      <div className="detail-background">
                        <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                      </div>
                    </aside>
                    <article className="middle-section">
                      <title className="title">
                        <div className="left">IDe</div>
                        <div className="right">
                          <strong>IDENTIDAD ELECTRÓNICA</strong>
                          <br />
                          <span>CREDENCIAL VERIFICABLE</span>
                        </div>
                      </title>
                      <section className="info-section gray">
                        <div className="subtitle">
                          <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                          <h2>Autotransporte</h2>
                          <h4>MODELO D</h4>
                        </div>
                        <hr className="bordeHr" />
                        <ul className="pNone">
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>Información Requerida</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>Conocimiento General</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>Validación de licencia</span>
                          </li>
                        </ul>
                        <div className="expires">
                          <span className="text-lg">Vence: {vigencia}</span>
                        </div>
                      </section>
                    </article>
                    <article className="right-section">
                      <div className="detail-finance identity">
                        <img src={carLogisticStr} alt="" className="w50px" />
                      </div>
                      <section className="qr-code">
                        <img className=" w50px" src={qr} alt="" />
                        <span className="cpv__text">CPV&nbsp;: {cpv}</span>
                      </section>
                      <section className="verify">
                        <img src={cardSvgP} alt="" />
                      </section>
                    </article>

                  </article>
                  <div className="text-one">
                    <div className="textInfo f12">
                      <b>ATENCIÓN:</b> El resultado obtenido <b>no es válido </b>si la fecha
                      en la parte superior izquierda de este <b>Reporte</b> se
                      encuentra <b>vencida.</b> Para comprobar su autenticidad escanee
                      el código QR y/o ingrese directamente el código CPV en
                      <b>www.midpr.net/verificar.</b>
                    </div>
                  </div>
                  <div className="textNotifique">
                    *Notifique si este Reporte es falso al +52 5571605526 y/o en
                    www.midpr.net
                  </div>
                </div>
                <div className="col-6">

                  <div className=" " id="">

                    <h4 className="text-center">Competencia en Autotransporte</h4>

                    <div className="subTitleCardTwo f12">
                      Este <b>Reporte</b> da constancia de la aplicación de manera
                      completa y concluyente de una <b>Evaluación Remota Confiable
                        (ERC&nbsp;)</b> realizada en la fecha indicada al calce, por el
                      Usuario, obteniendo el siguiente resultado:
                    </div>
                  </div>
                  <br />
                  <div className="titleCard">RESULTADO &nbsp; OBTENIDO</div>
                  <div className="containerCardTwo">
                    <div className="centerButton">
                      <div className="result">
                        <div className="graph-half-circle">
                          <div
                            className="image-graph position-relative"
                          >
                            <img
                              src={numImagenCompetencia}
                              style={{ width: "50%", height: "auto" }}
                              className="" />
                            <span className="percent-graph percentGraph">
                              {competencia}%
                            </span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-center  align-items-center">
                          <button type="button" className="inter">COMPETENCIA &nbsp; VIAL</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="textNotifique">
                    *La interpretación de este resultado obtenido es
                    responsabilidad exclusiva de quien lo recibe.
                  </div>
                </div>
              </div>

            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <div className=" " id="">
                    <div className="titleCard">
                      EXPERIENCIA &nbsp; PROFESIONAL
                    </div>
                    <div className="containerCardThree">

                      <div>
                        <table className="centerTable f12 ">
                          <thead className="titleTable ">
                            <tr>
                              <th>Experiencia</th>
                              <th>{accidentesTxt}</th>
                              <th>Largas &nbsp; distancias</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{experiencia} años</td>
                              <td>
                                {accidentes} {accidentesTxt}
                              </td>
                              <td>{distancias}</td>
                            </tr>
                            <tr>
                              <td>{equipo}</td>
                              <td>
                                {robos} {robosTxt}
                              </td>
                              <td>{conduccion}</td>
                            </tr>
                          </tbody>
                          <tfoot className="titleTable">
                            <tr>
                              <th className="leftBorder">Equipo</th>
                              <th>{robosTxt}</th>
                              <th className="rightBorder">Conducción &nbsp; nocturna</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div className="mt-5">
                      <table className="three-graphics">
                        <tbody>
                          <tr>
                            <td>
                              <div className="graph-half-circle">
                                <div className="image-graph">
                                  <img
                                    src={numImagenExperiencia}
                                    style={{ width: "90%", height: "auto" }}
                                  />
                                  <span className="percent-graph">
                                    {experienciaRes}%
                                  </span>
                                </div>
                                <span className="label-graph ">
                                  Experiencia
                                  <br />
                                  declarada
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="graph-half-circle">
                                <div
                                  className="image-graph"
                                >
                                  <img
                                    src={numImagenCapacidad}
                                    style={{ width: "90%", height: "auto" }}
                                  />

                                  <span className="percent-graph">
                                    {capacidadRes}%
                                  </span>
                                </div>
                                <span className="label-graph">
                                  Capacidad
                                  <br />
                                  técnica
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="graph-half-circle">
                                <div className="image-graph">
                                  <img
                                    src={numImagenSimilarity}
                                    style={{ width: "90%", height: "auto" }}
                                  />
                                  <span className="percent-graph">
                                    {similarity}%
                                  </span>
                                </div>
                                <span className="label-graph">
                                  Documentación
                                  <br />
                                  presentada
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {showTendencia ? (
                        <>
                          <div className="d-flex justify-content-center  align-items-center">
                            <button type="button" className="btn green trend">
                              TENDENCIA &nbsp; A CONSISTENTE
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-flex justify-content-center  align-items-center">
                            <button type="button" className="btn yellow trend">
                              TENDENCIA &nbsp; A INCONSISTENTE
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="textNotifique">
                      *Consulte definiciones de estas métricas en
                      www.midpr.net/resultados
                    </div>
                  </div>



                </div>

                <div className="col-6">

                  <div className="div-horizontal" id="">
                    <div className="titleCard"> ÁREAS &nbsp; EVALUADAS</div>
                    <div className="card evaluated-areas tipo-d borderCard">
                      <ul className="espacio-ul-left">
                        <li>
                          <div className="single">
                            <div className="title">Conocimiento  &nbsp;&nbsp;general</div>
                            <div className="graph-line">
                              <div className="content-graph">
                                {conocimientoArr}
                              </div>
                              <div className="text-graph">{conocimiento}%</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="single">
                            <div className="title">Alcohol y drogas</div>
                            <div className="graph-line">
                              <div className="content-graph">
                                {alcoholArr}
                              </div>
                              <div className="text-graph">{alcohol}%</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="single">
                            <div className="title">Peatones  &nbsp;&nbsp;y bicicletas</div>
                            <div className="graph-line">
                              <div className="content-graph">
                                {peatonesArr}
                              </div>
                              <div className="text-graph">{peatones}%</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="single">
                            <div className="title">Fatiga y manejo defensivo</div>
                            <div className="graph-line">
                              <div className="content-graph">
                                {fatigaArr}
                              </div>
                              <div className="text-graph">{fatiga}%</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="single">
                            <div className="title">Intersecciones &nbsp;&nbsp; y señalización</div>
                            <div className="graph-line">
                              <div className="content-graph">
                                {interArr}
                              </div>
                              <div className="text-graph">{interseccion}%</div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="textNotifique">
                      *Consulte definiciones de estas métricas en
                      www.midpr.net/resultados.
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <div className="div-vertical">
              <div className="div-horizontal" id="">

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-6">

                      <div className="subTitleCardTwo f12">
                        Esta ERC &nbsp; fue realizada de manera automatizada a través de
                        un dispositivo digital propiedad del Aplicante. Durante el
                        proceso, se registraron una serie de datos de carácter
                        personal que fueron analizados, validados y/o verificados
                        que permitieron, posterior al análisis de la información,
                        la obtención del dictamen presentado con respecto a la
                        congruencia o incongruencia de estos de manera integral.
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="card evaluated-areas tipo-d borderCard">
                        <div className="titleContainerSinBorder">
                          LICENCIA DE CONDUCIR
                        </div>
                        <div className=" f12">
                          Número  : <b>{numeroLic} </b><br />
                          Nombre  : {tipoLic} <br />
                          Emisor  : {edoEmisor} ( {edoEmisorISO} ) <br />
                          País    : MX/ México <br />
                          Emitido : {vigencia} <br />
                          Estatus : {validadoTxt}<br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="note-gray note-emit">
                  <p>
                    {emiteTxt}
                  </p>
                </div>

                <div className="textNotifique">
                  *Consulte al reverso de este Reporte nuestra Política de
                  Privacidad y/o en www.midpr.net/privacidad
                </div>

                <div className="titleCard">AVISO &nbsp; LEGAL</div>
                <div className="card legal-advise borderCard">
                  <div className="subTitleCardTwo f12">
                    <p>
                      La <strong> &nbsp; Calificación &nbsp;</strong> realizada de manera
                      remota por el <strong>Aplicante</strong>, a la que hace
                      referencia este <strong>Reporte</strong>, fue realizada
                      a solicitud directa del <strong>Destinatario</strong>.
                      Antes y durante la <strong>Calificación</strong>, fue
                      autenticada la identidad del <strong>Aplicante</strong>{" "}
                      y se registraron una serie de datos e información de
                      carácter personal con su autorización expresa, lo cual
                      permitió emitir una Evaluación Remota Confiable ( &nbsp; ERC &nbsp;).
                      El <strong>Destinatario</strong> acepta que todos los
                      datos contenidos en el presente <strong>Reporte</strong>{" "}
                      son confidenciales y de interés exclusivo y privado, que
                      es compartida únicamente con el propósito que ha sido
                      previamente informado por el{" "}
                      <strong>Destinatario</strong> y que ha autorizado por el{" "}
                      <strong>Aplicante</strong> previo a la aplicación de la{" "}
                      <strong>Calificación</strong>. El{" "}
                      <strong>Aplicante</strong> y/o el{" "}
                      <strong>Destinatario</strong> de este Reporte aceptan de
                      conformidad la responsabilidad sobre cualquier uso
                      indebido o ilegal de este documento y su contenido, así
                      como todos los términos y condiciones descritos al
                      reverso.{" "}
                      <strong>
                        Una vez entregado este Reporte al Destinatario, el
                        Fabricante se deslinda de toda responsabilidad sobre
                        su interpretación, divulgación y uso
                      </strong>
                      .
                    </p>
                  </div>
                </div>

                <div className="textNotifique">
                  <b>Business &nbsp; Prey SA</b> de <b>CV</b> hace referencia que con número de
                  registro DGSP /369-19/3919, está autorizada por la SSPC &nbsp;/DGSP
                  para la aplicación de Pruebas y Evaluación de Control de
                  Confianza de conformidad con los Lineamientos y Criterios
                  Técnicos &nbsp; publicados en el Diario Oficial de la Federación
                  (DOF) el 28 de abril de 2020.
                </div>
                <div style={{ paddingTop: "0px", background: "#FFF" }}>
                </div>
              </div>
            </div>

            {/* hoja 2 */}
            <div className="titleCard">DOCUMENTOS &nbsp; PRESENTADOS</div>
            <div className="card presented  ContainerCardIne ">
              <div className="row justify-content-center m1  h-100 align-items-center">
                <div className="col-6 d-flex justify-content-center  h-100">
                  <img src={imagenFront} alt="" className="PassPort--sizing w-100 " />

                </div>
                <div className="col-6 d-flex justify-content-center h-100">

                  <img src={imagenBack} alt="" className="PassPort--sizing w-100" />
                </div>
              </div>
            </div>

            <div className="div-vertical">
              <div className="div-horizontal" id="">

                <div className="cardLeft">
                  <div className="subTitleCardTwo">
                    <b>Business &nbsp; Prey SA de CV (BP)</b>, Fabricante exclusivo en la
                    República Mexicana para DPR, con número de registro
                    autorización DGSP/369-19/3919 expedido por la Dirección
                    General de Seguridad Privada (DGSP&nbsp;) de la Secretaría de
                    Seguridad y Protección Ciudadana (SSPC&nbsp;) para la aplicación
                    de pruebas de evaluación de control de confianza en
                    términos de los Lineamientos y Criterios Técnicos que
                    deberán cumplir las Empresas de Seguridad Privada bajo la
                    Modalidad VI, previsto en el artículo 15 de la Ley Federal
                    de Seguridad Privada (LFSP&nbsp;), publicados con fecha de 28 de
                    abril de 2020, en el Diario Oficial de la Federación (DOF)
                    y en cumplimiento con lo dispuesto por los artículos 1, 3,
                    6, 7, 8, 12 y 14 de la Ley Federal de Protección de Datos
                    Personales en Posesión de los Particulares emite el
                    resultado de la presente Evaluación Remota Confiable
                    (ERC&nbsp;).
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Aplicación de la Evaluación ERC &nbsp;</b> La presente ERC&nbsp; fue
                    acotada a una Área de Interés específica mediante un
                    proceso remoto que el Aplicante aceptó de manera expresa y
                    totalmente voluntaria someterse a la evaluación, con la
                    finalidad de ser calificado en diversas Temáticas con lo
                    que se estimó el Resultado Obtenido, conforme a la
                    metodología y marcos de referencia establecidos por DPR
                    para tal efecto. Para la realización de la ERC&nbsp;, el
                    Aplicante utiliza dispositivos electrónicos de su
                    propiedad, fuera del control del Fabricante, por lo que se
                    aplican avanzados métodos de validación y verificación de
                    datos para asegurar su veracidad y autenticidad.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Declaración de Veracidad</b> Esta evaluación ERC &nbsp; puede o no
                    formar parte de un proceso de certificación que incluye
                    una Prueba DPR. Al presentar esta ERC &nbsp;, el Aplicante acepta
                    y se somete a una declaración bajo protesta de decir
                    verdad de proporcionar información fidedigna. La veracidad
                    de la misma puede ser comprobada durante o posteriormente.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Proceso de Calificación</b> La ERC&nbsp; incluye un conjunto de
                    Áreas Evaluadas que incluyen Temas de Interés que son
                    requisitados para obtener un Resultado y un Dictamen. La
                    información que se recaba y se procesa durante la
                    evaluación se describen en este Reporte y corresponden a
                    una dimensión particular de datos adquiridos del
                    Aplicante.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Interpretación de los Resultados &nbsp;</b> Esta ERC &nbsp; incluye los
                    diversas Temas de Interés para obtener un Resultado
                    Obtenido y el Dictamen de veracidad o congruencia, que son
                    exclusivamente un parámetro medido en porcentaje y/o una
                    valoración cualitativa correspondientemente, por lo que no
                    existe un valor o magnitud específica que sea aprobatoria
                    o no aprobatoria. Es responsabilidad exclusiva del
                    Destinatario establecer el umbral mínimo o máximo
                    esperado, para la determinación de la aceptación del
                    Aplicante o para la permanencia de acuerdo a los
                    Resultados Obtenidos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Emisión del Certificado</b> Al culminar de manera concluyente
                    esta ERC &nbsp;, el resultado se procesa en un periodo máximo de
                    24 horas. El resultado, datos y dictamen descrito en este
                    Reporte, es sellado digitalmente mediante un Certificado
                    Personal Verificable (CPV &nbsp;) de forma numérica o en QR que
                    puede ser utilizado para confirmar la vigencia y
                    autenticidad del mismo en la página
                    www.midpr.net/verificar. Este Reporte deberá ser
                    considerado como falso, si la consulta no resulta en la
                    leyenda de “Verificado”.
                  </div>
                </div>
                <div>
                  <div className="subTitleCardTwo">
                    <b>Privacidad de Datos Personales &nbsp;</b> Para &nbsp; efectos del
                    cumplimiento del artículo 9 de la Ley Federal de
                    Protección de Datos Personales en Posesión de los
                    Particulares (LFPDPPP&nbsp;), el Aplicante de la ERC manifiesta
                    expresamente que otorgó su consentimiento para el
                    tratamiento de sus datos personales sensibles, durante los
                    procedimientos de recopilación y procesamiento, aceptando
                    los términos y condiciones para tales efectos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de las Marcas</b> DPR y las marcas asociadas son marcas
                    registradas, protegida por los artículos 88 y 142 de la
                    Ley de Propiedad Industrial (LPI&nbsp;), así como el convenio de
                    París para efectos internacionales. El consumo o
                    adquisición de cualquiera de los servicios vinculados a
                    DPR &nbsp; y/o proporcionados por el Fabricante, no confieren al
                    Aplicante y/o al Destinatario el derecho de uso de las
                    marcas de DPR &nbsp; en ningún contexto y/o formato, ya que al
                    hacerlo podría resultar en actividad fraudulenta y ser
                    clasificado como un delito. La marca, propiedad
                    intelectual o cualquier otro tipo de secreto industrial
                    contenido en este Reporte, no autoriza el uso, explotación
                    comercial, venta, reproducción o distribución de dicha
                    información.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de Información por Terceros</b> Al realizar la ERC, el
                    Aplicante autoriza la entrega del resultado obtenido al
                    Destinatario para el uso particular que ambos hayan
                    acordado. Para el caso exclusivo de Elementos de Seguridad
                    Privada, la entrega de este Reporte a la DGSP, se hará
                    conforme a lo previsto en el artículo 9 de los citados
                    Lineamientos y Criterios Técnicos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>
                      En DPR estamos a favor de la confianza profesional, la
                      honestidad y transparencia, la privacidad de datos
                      personales, la equidad de género, la inclusión financiera
                      y digital, la igualdad de oportunidades y la no
                      discriminación.
                    </b>
                  </div>

                  <div className="card evaluated-areas tipo-d borderCard">
                    <div className="titleContainerSinBorder">
                      TEMAS DE INTERÉS
                    </div>
                    <div className="subTitleCardTwo">
                      <ul className="espacio-ul-left">
                        <li>
                          <strong>Experiencia profesional:</strong> Alos de experiencia, Equipo de autotransporte,
                          Involucración en accidentes, Robos de mercancía, Largas disatancias, Conducción nocturna.
                        </li>
                        <li>
                          <strong>Conocimiento vial:</strong> Conocimiento general, Alcohol y drogas, Peatones y bicicletas,
                          Fatiga y manejo defensivo, intersecciones y señalizacíon
                        </li>
                        <li>
                          <strong>Licencia de conducir:</strong> Score
                        </li>
                      </ul>
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="note-gray">
                    <p>
                      <strong>Business &nbsp; Prey SA de CV</strong> con domicilio en
                      Alfonso Reyes &nbsp; 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                      DPR. Para mayor información llame al +52 5571605526 o
                      visite el sitio <strong>www.midpr.net</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AutoTransporte;
